import { isObject } from 'lodash'
import { formatIsoDateCustom, currentDatetime } from '@/global/services/helpers/dates'
const FORM_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DISPLAY_DATETIME_FORMAT = 'DD.MM.YYYY. HH:mm'
export default {
  name: 'basicInfoConfig',

  data () {
    return {
      internalDataVisible: false
    }
  },

  computed: {
    roadInformation () {
      return {
        title: this.$t('road-maintenance.road_information'),
        key: 'road-information',
        visible: this.$route.query.category !== 'request_new' || !!this.$route.meta.show,
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: () => {
              return this.$route.params.id ? `traffic-regulation/${this.$route.params.id}/road-information` : 'traffic-regulation/road-information'
            },
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/road-information`,
            method: 'get'
          }
        },
        editUpdate: (event) => this.roadInformationEditUpdated(event),
        dataFetched: (event) => this.onRoadInfoDataFetched(event),
        afterCancel: (event) => this.onRoadInfoDataFetched(event),
        afterSave: (event) => this.onRoadInfoDataFetched(event),
        modifyDataBeforeSend: (event) => this.roadInfoModifyDataBeforeSend(event),
        hiddenFormKeys: [
          'streets',
          'type_id',
          'subtype_id',
          'start_time',
          'end_time'
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance.road_information'),
            showEditButtons: true,
            showBackButton: {
              uiViewName: this.$route?.meta?.parent_vue_name ?? null
            },
            onCancelTabSave: (event) => this.onCancelRoadInformationCreate(event)
          },
          {
            component: this.informationAboutRouteComponent,
            visible: this.internalDataVisible
          },
          {
            component: this.drawRoadRegulationComponent,
            type: 'dynamic-columns',
            key: 'road_regulation',
            dataKey: 'streets'
          }
        ]
      }
    }
  },

  methods: {
    roadInformationEditUpdated (event) {
      const { edit, createMode } = event || {}
      this.edit = !!edit

      this.internalDataVisible = !this.edit && !createMode
    },

    onCancelRoadInformationCreate (event) {
      const { cancelTabSave } = event || {}
      if (this.$route.query.category === 'request_new') {
        this.$router.push({
          name: 'Aggregator_road_information'
        }).then()
      }
      else if (typeof cancelTabSave === 'function') {
        cancelTabSave()
      }
    },

    onRoadInfoDataFetched (event) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Modify dates to be in format: DISPLAY_DATETIME_FORMAT
          start_time: data?.start_time ? formatIsoDateCustom(data.start_time, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : currentDatetime(DISPLAY_DATETIME_FORMAT),
          end_time: data?.end_time ? formatIsoDateCustom(data.end_time, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : currentDatetime(DISPLAY_DATETIME_FORMAT)
        })
      }
    },

    roadInfoModifyDataBeforeSend (event) {
      const { originalData } = event || {}

      if (originalData) {
        // Modify dates to be in format for send: FORM_DATETIME_FORMAT
        originalData.start_time = originalData.start_time ? formatIsoDateCustom(originalData.start_time, DISPLAY_DATETIME_FORMAT, FORM_DATETIME_FORMAT) : currentDatetime(FORM_DATETIME_FORMAT)
        originalData.end_time = originalData.end_time ? formatIsoDateCustom(originalData.end_time, DISPLAY_DATETIME_FORMAT, FORM_DATETIME_FORMAT) : currentDatetime(FORM_DATETIME_FORMAT)
      }

      return originalData
    }
  }
}
